<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBandwidth_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g clip-path="url(#IconBandwidth_16__a)">
        <path
            fill="currentColor"
            d="M15.9 8.726C15.317 5.012 12.04 2 8 2a8 8 0 0 0-8 8c0 1.243.288 2.417.796 3.466a.98.98 0 0 0 .888.534h12.633a.98.98 0 0 0 .887-.534 7.97 7.97 0 0 0 .696-4.74m-3.206-.757-3.971 3.912A1.51 1.51 0 1 1 7.016 9.44l5.038-2.386c.576-.273 1.094.468.64.915"
        />
    </g>
    <defs>
        <clipPath id="IconBandwidth_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
